import sortByProp from '../../lib/sortByProp.js';
import mapToCamelCase from '../../lib/mapToCamelCase.js';

const formatUsers = (users) =>
  (users || [])
    .sort(sortByProp('first_name'))
    .map(mapToCamelCase)
    .map((n) => ({
      ...n,
      roles: String(n.roles || '')
        .split(',')
        .filter((n) => !!n)
        .filter((n) => !!n),
    }));

export default formatUsers;
